import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2103Role } from "../../../../U2103Service";
import type { U2103UserRoleHandler } from "./U2103UserRoleHandlers";

// Typage des props du composant
interface U2103UserRoleDeleteDlgProps {
  u2103UserRoleHandler: U2103UserRoleHandler;
  t: TFunction;
  NS: string;
}

function U2103UserRoleDeleteDlg({ u2103UserRoleHandler, t, NS }: U2103UserRoleDeleteDlgProps) {
  // Plus besoin de helpers custom, U2000CheckBoxArray gère tout

  if (!u2103UserRoleHandler.isDeleteDialogOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={u2103UserRoleHandler.isDeleteDialogOpen} onClose={u2103UserRoleHandler.onDlgDeleteClose} title={t("lblLogicalUnitAction", { ns: NS })}>
      <p className="mb-4">
        {t("msgDeleteLogicalUnitAction", {
          count: u2103UserRoleHandler.gridStateHandlers.getSelectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {u2103UserRoleHandler.gridStateHandlers.getSelectedRows().map((row, index, array) => {
          const role = row as unknown as U2103Role;
          return (
            <span key={role.roleCode} className="inline-block text-gray-800">
              {`${role.roleCode} - ${role.roleDescription}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U2103UserRoleDeleteDlg;
